import React from 'react';
import { ArrowRight, PlayCircle } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative min-h-[600px] lg:min-h-[700px] overflow-hidden" data-id="element-57">
      {/* Full background image */}
      <img src="https://cdn.magicpatterns.com/uploads/sD9M9su7pAhX2cFowiH6Vh/hermes-rivera-Ww8eQWjMJWk-unsplash.jpg" alt="Fresh, colorful salad bowl" className="absolute inset-0 h-full w-full object-cover" data-id="element-58" />

      {/* Gradient overlay — fades the left/text side for legibility */}
      <div className="absolute inset-0 bg-gradient-to-r from-stone-50 via-stone-50/95 via-50% to-transparent" data-id="element-59" />

      {/* Content */}
      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20 lg:py-32" data-id="element-60">
        <div className="max-w-xl" data-id="element-61">
          <h1 className="font-serif text-4xl font-bold tracking-tight text-stone-900 sm:text-5xl md:text-6xl lg:leading-tight" data-id="element-62">
            End the confusion around food.{' '}
            <span style={{
            color: '#4bc041'
          }} className="italic" data-id="element-63">
              Start building habits
            </span>{' '}
            that actually last.
          </h1>
          <p className="mt-6 text-lg leading-relaxed text-stone-600" data-id="element-64">
            Personalized nutrition coaching from friendly, licensed dietitians
            in North Carolina &amp; online. We help you find balance without the
            restriction.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-4" data-id="element-65">
            <Button size="lg" className="group" data-id="element-66">
              Book a Free Clarity Call
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-67" />
            </Button>
            <Button variant="ghost" size="lg" className="group" data-id="element-68">
              <PlayCircle className="mr-2 h-5 w-5 text-stone-400 group-hover:text-stone-600" data-id="element-69" />
              Learn How It Works
            </Button>
          </div>
          <div className="mt-10 flex items-center gap-4 text-sm text-stone-500" data-id="element-70">
            <div className="flex -space-x-2" data-id="element-71">
              {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-8 rounded-full border-2 border-white bg-stone-200" data-id="element-72" />)}
            </div>
            <p data-id="element-73">Trusted by 500+ clients in NC</p>
          </div>
        </div>
      </div>
    </section>;
}